import React from 'react'
import { createContext } from 'src/util'
import { useLocalStorageReducer } from 'src/hooks'

/**
 * Context used to manage user preferences:
 */
export default createContext(
  Provider =>
    // eslint-disable-next-line react/prop-types
    function LocalSettingsContext({ value, ...props }) {
      // Handle the collapsed state of the sidebar
      const [isSidebarCollapsed, toggleSidebar] = useLocalStorageReducer('isSidebarCollapsed', value => !value, false)

      // Handle the vertical zoom of the chart
      const [isChartVerticalZoomEnabled, toggleChartVerticalZoom] = useLocalStorageReducer(
        'isChartVerticalZoomEnabled',
        value => !value,
        false
      )

      // provide props
      return (
        <Provider
          value={{
            isSidebarCollapsed,
            toggleSidebar,
            isChartVerticalZoomEnabled,
            toggleChartVerticalZoom,
          }}
          {...props}
        />
      )
    },
  {}
)
